import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import SelectableContext, { makeEventKey } from '../SelectableContext';
import NavContext from '../Navs/NavContext';
import { SafeAnchor } from '../SafeAnchor';
export const MenuItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, children, eventKey, disabled = false, href, header, divider, text, onClick, onSelect, active: propActive, componentClass = SafeAnchor, ...rest } = props;
    const onSelectCtx = useContext(SelectableContext);
    const navContext = useContext(NavContext);
    const { activeKey } = navContext || {};
    const key = makeEventKey(eventKey, href);
    const active = propActive == null && key != null ? makeEventKey(activeKey) === key : propActive;
    const handleClick = useEventCallback((event)=>{
        // SafeAnchor handles the disabled case, but we handle it here
        // for other components
        if (disabled) return;
        if (onClick) onClick(event);
        if (onSelectCtx) onSelectCtx(key, event);
        if (onSelect) onSelect(key, event);
    });
    let prefix = '';
    let Component = componentClass;
    if (text) {
        Component = 'span';
        prefix = 'dropdown-item-text';
    } else if (header) {
        Component = 'h6';
        prefix = 'dropdown-header';
    } else if (divider) {
        Component = 'hr';
        prefix = 'dropdown-divider';
    } else {
        prefix = 'dropdown-item';
    }
    return /*#__PURE__*/ _jsx(Component, {
        ...rest,
        ref: ref,
        href: href,
        disabled: disabled,
        className: classNames(className, prefix, active && 'active', disabled && 'disabled'),
        onClick: handleClick,
        children: children
    });
});
MenuItem.displayName = 'MenuItem';
